// Func = limiting Scope for this file
var topp ;
var scrollParallax = [];
var heroH;

var allheights = [];
var tallestH = 0;

function openVideo(){
	let videoUrl;
    $('.open-video').click(function(event){
        event.preventDefault();
        videoUrl = $(this).attr('data-video');

    })
    $('.open-video').fancybox({
        afterShow   :   function() {
            const video = $('#lightbox-video');
			video.attr('src', videoUrl);
			video.prop('muted', true);
			video[0].play();
        },
        overlayShow : true,
        centerOnScroll : true,
        speedIn : 100,
        speedOut : 50,
        allowfullscreen:true,
        width         : '100%',
        height        : '100%',
        autosize: false
    });
}

(function(){

	//if Explorer 11
	if(!(window.ActiveXObject) && "ActiveXObject" in window){
	
		if(document.getElementsByTagName('canvas').length > 0){
			for(let j = 0; j < document.getElementsByTagName('canvas').length; j++){
				document.getElementsByTagName('canvas')[j].classList.add('ie');
			}
		}
		
		//explorer booking
		setTimeout(function(){
			if(document.getElementsByClassName('daterangepicker').length > 0){
				for(let j = 0; j < document.getElementsByClassName('daterangepicker').length; j++){
					document.getElementsByClassName('daterangepicker')[j].classList.add('ie');
				}
			}
		}, 500);	
	}
	window.addEventListener('scroll', function(){
        scrollDown();
	});
	window.onresize = function(){
        resizeWindow();
	}
	//primary nav active effect
	for(let i=0; i < document.getElementById('primary-nav').getElementsByTagName('a').length; i++){
		if(document.getElementById('primary-nav').getElementsByTagName('a')[i].classList.contains('active')){
			document.getElementById('primary-nav').getElementsByTagName('a')[i].parentNode.classList.add('active');
		}
	}

	//booking benefits addition
	let bookinglist = document.getElementsByClassName('bookbenefits-block')[0];
	// let bookingblock = document.getElementsByClassName('booking-widget-inline-date')[0];
	// bookingblock.appendChild(bookinglist);

	//Menu burger
	document.getElementById('menuBurger').addEventListener('click', function(){
		if(!this.classList.contains('open')){
			this.classList.add('open');
			document.getElementById('primary-nav').classList.add('open');
		} else {
			this.classList.remove('open');
			document.getElementById('primary-nav').classList.remove('open');
		}
	});



	//btn
	if(document.getElementsByClassName('btn').length > 0){
		let allbtn = document.getElementsByClassName('btn');
		for(let g = 0; g < allbtn.length; g++){
			let btninner = allbtn[g].innerHTML;
			allbtn[g].innerHTML = '<span>' + btninner + '</span>';
		}
	}


	//images mask with canvas
	if(document.getElementsByClassName('mask').length > 0){
		for(let c = 0; c < document.getElementsByClassName('mask').length; c++){
			let canvas = document.getElementsByClassName('mask')[c].getElementsByTagName('canvas')[0];
			let ctx = canvas.getContext('2d');
			let img = document.createElement('img');
			img.onload = function () {

				// Save the state, so we can undo the clipping
				ctx.save();
				// Create a shape, of some sort
				ctx.beginPath();

				ctx.moveTo(345, 50);
				ctx.quadraticCurveTo(620,50,680,350);
				ctx.quadraticCurveTo(685,650,350,675);
				ctx.quadraticCurveTo(45,650,50,345);
				ctx.quadraticCurveTo(50,45,345,50);

				ctx.closePath();
				// Clip to the current path
				ctx.clip();
				ctx.drawImage(img, 0, 0);
				// Undo the clipping
				ctx.restore();
			}
			// Specify the src to load the image
			img.src = document.getElementsByClassName('mask')[c].getAttribute('data-src');
		}
	}

	//map ADA page
	if(document.getElementsByTagName('body')[0].classList.contains('map')){
		//ada-map
		let adalink = document.createElement('a');
		adalink.classList.add('return-from-map');
		adalink.classList.add('btn');
		adalink.innerHTML = '<span>Visit ADA page</span>';
		adalink.setAttribute('href',site_url + 'ada-map');
		document.getElementById('content').appendChild(adalink);
		
	}

	
	$(document).ready(function () {
		//rellax
		if(document.getElementsByClassName('rellax').length > 0){
			var rellax = new Rellax('.rellax');
		}
			
		
		

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: 'yy-mm-dd',
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: 'yy-mm-dd',
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});
		
	});

}());

//window offset
function offset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}
function ready(){
	scrollDown();
	resizeWindow();
	contentFade();
}

function contentFade(){
	document.getElementById('start-content').classList.add('ready');
}
function resizeWindow(){
	var w=window,
		d=document,
		e=d.documentElement,
		g=d.getElementsByTagName('body')[0],
		windowWidth=w.innerWidth||e.clientWidth||g.clientWidth,
		windowHeight=w.innerHeight||e.clientHeight||g.clientHeight;
	
	//default page
	// if(document.getElementById('default')){
	// 	if(windowWidth > 1090 ){
	// 		let headerH = windowHeight - 250;
	// 		document.getElementsByClassName('top-content')[0].style.height = headerH + 'px';
	// 	}
	// }
	if(document.getElementsByClassName('header-img').length > 0){
		heroH = document.getElementsByClassName('top-content')[0].offsetHeight + 38;
	}

	//init get directions
	if(document.getElementsByClassName('get-directions').length > 0){
		let eachitem = document.getElementsByClassName('cta-tab');
		for(var j = 0; j < eachitem.length; j++){
			var titleH = eachitem[j].getElementsByTagName('h3')[0].offsetHeight + 40;
			eachitem[j].style.height = titleH + 'px';
		}
	}

	//columns height even -_-
	if(document.getElementsByClassName('columns-block').length > 0){
		let allcolumns = document.getElementsByClassName('columns-block');
		for(let h = 0; h < allcolumns.length; h++ ){
			allheights = [];
			tallestH = 0;
			let eachcolumns = allcolumns[h].getElementsByClassName('columns-block__item');
			for(let j = 0; j< eachcolumns.length; j++){
				allheights.push(eachcolumns[j].getElementsByClassName('top-copy')[0].offsetHeight);
			}
			tallestH = allheights.reduce(function(a,b){
				return a > b ? a : b;
			});
			console.log(tallestH);
			for(let j = 0; j< eachcolumns.length; j++){
				eachcolumns[j].getElementsByClassName('top-copy')[0].style.height = tallestH + 'px';
			}
		}
	}

	//#home .home-map img
	if(document.getElementById('home')){
		let imgH = document.getElementsByClassName('home-map')[0].getElementsByTagName('img')[0].offsetHeight;
		document.getElementsByClassName('home-map')[0].getElementsByClassName('pins')[0].style.height = imgH + 'px';
	}
	
}
function scrollDown(){
	//if Explorer 11
	if(!(window.ActiveXObject) && "ActiveXObject" in window){
		topp= document.documentElement.scrollTop;
	} else {
		topp = window.pageYOffset;
	}

	//lazy conflict
	const top = window.scrollY;
	let animatedEl = document.getElementsByClassName('animate-fade-2');
	const h = window.innerHeight;
	var i;
	for (i = 0; i < animatedEl.length; i++) {
		var viewportOffset = animatedEl[i].getBoundingClientRect();
		let topPos = viewportOffset.top;
		//animatedEl[i].innerHTML = topPos;
		if(topPos <= h*0.8){
			animatedEl[i].classList.add('fade-in');
		}
	}

	if(document.getElementById('home')){
		if(topp > 100){
			if(!document.getElementById('header').classList.contains('scroll')){
				document.getElementById('header').classList.add('scroll');
			}
		} else {
			if(document.getElementById('header').classList.contains('scroll')){
				document.getElementById('header').classList.remove('scroll');
			}
		}
	} else {
		if(!document.getElementById('header').classList.contains('scroll')){
			document.getElementById('header').classList.add('scroll');
		}
	}

	//submenu
	if(document.getElementsByClassName('sub-menu').length > 0){
		if(topp > heroH ){
			if(!document.getElementsByClassName('sub-menu')[0].classList.contains('top')){
				document.getElementsByClassName('sub-menu')[0].classList.add('top');
			}
		} else {
			if(document.getElementsByClassName('sub-menu')[0].classList.contains('top')){
				document.getElementsByClassName('sub-menu')[0].classList.remove('top');
			}
		}
	}
}